
export interface ColumnType {
  field: string,
  header: string,
  isDisplay?: string,
  header_label?: string;
}

export interface FilterType {
  label: string,
  value: string
}

export interface FilterRuleType {
  column: string,
  filtertype: string,
  value: any,
  isApplied: boolean;
  disableValue?: any;
  customSearchType?: string;
  filterTypes?: any;
}

export interface ListConfigData {
  columns: RefrralHeaderType[],
  buttons: ButtonConfig[],
  pageName: string;
  orderBy: string[];
  orderByColumn: string[];
}

export interface ButtonConfig {
  button_id: string,
  button_label: string,
  buttonAction: string,
  className: string
}


export interface RefrralHeaderType {
  header_id: string;
  header_label: string;
  jsonpath: string;
  isDisplayedAtHeader: string;
  isSearchable: string;
  header?: string;
  textTruncateMinLimit? : string;
}

export interface ListGridRequestPayload {
  pageName: string;
  programCode: string;
  condition: string;
  recordsPerPage: number;
  startingPageNumber: any;
  searchParam: SearchParams[];
  orderBy: any;
  orderByColumn: any;
  export?: boolean;
}

export interface UploadRequestPayload{
  file: any;
  json:{}
}


export interface SearchParams {
  jsonPath: string;
  value: string;
  operator: string;
}

export interface TableRowActionsModel {
  edit: boolean;
  delete: boolean;
  view: boolean;
  download: boolean;
  verify: boolean;
  add: boolean;
  refresh: boolean;
  mail: boolean;
  approve: boolean;
  deny: boolean;
  schedule: boolean;
  select: boolean;
  unmask: boolean;
  deactivate: boolean;
  editHistory: boolean;
  auditHistory: boolean;
  updateCap: boolean;
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  View = 'view',
  Download = 'download',
  Verify = 'verify',
  Add = 'add',
  Refresh = 'refresh',
  Mail = 'mail',
  unmask = 'unmask',
  deactivate = 'deactivate'
}